import React from 'react';
import { useNavigate } from 'react-router-dom';
import FullScreen from './fullScreen';
import * as Config from "../lib/config";
import './FullScreenView.css';

const FullScreenView = (props) => {
  const navigate = useNavigate();
  const {
    fontSize,
    name,
    isMobile,
    speed,
    RGB,
    isblink,
    blinkSpeend,
    isFlipText,
    bgColor,
    setName,
    color,
    finalResult
  } = props;

  const handleBack = () => {
    navigate('/');
  };

  return (
    <div className="fullscreen-view">
      <button className="back-button" onClick={handleBack}>
        <img
          src={Config.images.leftArrow}
          alt="Back"
          width="24"
          height="24"
        />
      </button>
      
      <FullScreen
        fontSize={fontSize}
        name={name}
        isMobile={isMobile}
        speed={speed}
        RGB={RGB}
        isblink={isblink}
        blinkSpeend={blinkSpeend}
        isFlipText={isFlipText}
        bgColor={bgColor}
        setName={setName}
        color={color}
        finalResult={finalResult}
      />
    </div>
  );
};

export default FullScreenView; 